// "RETURN HOME" button — sits above the view-rotate arrows + UI minimap (left rail). It exists only while the cat is away in the
// Capital (the way IN is the first card of the ADVENTURE panel: see ui/adventurePanel.js). At home it is hidden.

import { Events, on } from './eventBus.js'
import { leaveAway } from '../game/awayState.js'

export function mountCapitalButton() {
  if (document.querySelector('.capital-btn')) return // idempotent

  const btn = document.createElement('button')
  btn.className = 'capital-btn'
  btn.type = 'button'
  btn.innerHTML = '<span class="capital-btn__main">RETURN HOME</span><span class="capital-btn__cn">归家</span>'
  btn.title = 'Travel back to your kingdom (H)'
  document.body.appendChild(btn)

  const s = { active: false, busy: false }
  const render = () => {
    btn.classList.toggle('is-away', s.active) // hidden unless away (see hud.css)
    btn.disabled = s.busy
  }

  btn.addEventListener('click', () => {
    if (btn.disabled || !s.active) return
    leaveAway() // whichever place we are in answers
  })
  on(Events.AwayChange, (p) => { s.active = !!p.active; s.busy = !!p.busy; render() })
  render()
}
